import React, { useEffect } from "react";
import SessionManager from "@Core/session";
import { useSearchParams } from "@Utils";
import StudentAssessmentTable from "./StudentAssessmentTable";
import StudentSubmissions from "./StudentSubmissions";
import StudentTaskSubmission from "./StudentTaskSubmission";
import { useUserAssessmentsInstancesQuery } from "./queries";
import { IAssessmentProps } from "./types";

const StudentAssessments: React.FC<IAssessmentProps> = ({ tab }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const assessmentId = searchParams.get("assessment");

  const { userId } = SessionManager.getServiceUser();

  const { data: assessmentInstances } = useUserAssessmentsInstancesQuery(userId);

  const assessmentInstance = !!assessmentId
    ? assessmentInstances?.find((ai) => ai.assessmentId === assessmentId)
    : null;

  const isAssigned = assessmentId && tab === "assigned" && assessmentInstance?.status === "assigned";

  useEffect(() => {
    if (!assessmentInstance || assessmentInstance?.status === tab) return;

    setSearchParams({ tab: assessmentInstance.status, assessment: assessmentId }, { replace: true });
  }, [assessmentId, assessmentInstance, setSearchParams, tab]);

  return (
    <section>
      {(isAssigned && <StudentTaskSubmission />) ||
        (assessmentId && !isAssigned && <StudentSubmissions assessmentInstance={assessmentInstance} tab={tab} />) || (
          <StudentAssessmentTable tab={tab} />
        )}
    </section>
  );
};

export default StudentAssessments;
